import React, { useContext, useState,useEffect } from 'react';
import useLocalStorageState from 'use-local-storage-state';
import SimpleContext from '../context/SimpleContext';


const SearchBrands = ({stylee,setpage,page}) => {
    const context = useContext(SimpleContext);
    const [isLoading, setIsLoading] = useState(true);
    const HandleSearchProduct = (pre) => {
        context.setsearchBodyOfProduct({})
        context.setFilterPriceRange([0,0])
        context.search(0,context.SearchField,0,0,context.SelectedBrandsList,context.sort,0,0,0,context.searchBodyOfProduct);
        context.categories(0,context.SelectedBrandsList) 
    }
    const HandleSelectedBrandsList = (id,pre) => {
        setpage(0)
        pre=true
        let qBrandsList = context.SelectedBrandsList.indexOf(id)
        if (qBrandsList === -1) {
          
            context.SelectedBrandsList.push(id)
            document.getElementById(id).style.filter = "none"
            context.setdeleteAllBrandsInSearch(false)
        }
        else{
           
            context.SelectedBrandsList.splice(qBrandsList, 1);
        }
        if (context.SelectedBrandsList.length === 0) {
           
            context.setdeleteAllBrandsInSearch(false)
        }else{
            context.setdeleteAllBrandsInSearch(true)
        }
       
        HandleSearchProduct(pre)
    }
    
    function handleDeleteFilters(){
        setpage(0)
        context.setTreeMenuSelectedId(0);
        context.setSearchField("");
        context.setFilterPriceRange([0, 0]);
        context.setSelectedBrandsList([]);
        context.search(0,context.SearchField,0,0,[],context.sort,0,0,0)
        context.categories(0,context.SelectedBrandsList)
    }
    const addDefaultSrc =(ev) =>{ 
        ev.target.src ="/images/placeholder.jpg"
    }
    return (  
        <>
        {
            context.searchProducts.brandList.length > 0 ?
            <>
                {
                    context.SelectedBrandsList.length>0?
                        <div className="deleteFilterBtnSearch" onClick={()=> handleDeleteFilters()}>
                            <p style={{margin:"0"}}>حذف فیلتر</p>
                            <i className="fa fa-times"></i>
                        </div>
                    :
                        null
                }
            
                {
                    context.searchProducts.brandList.map((i,j)=>
                
                        <div className={i.isSelected===true?"brands_search":"brands_search_holderMini"} key={j} onClick={() => HandleSelectedBrandsList(i.id,i.pre)}>
                            <p style={{fontSize:"10px",fontWeight:'bold',margin:'0'}}>{i.name}</p>
                            <img onError={addDefaultSrc}  alt='برند' id={i.id} src={i.img}  className={stylee}/>
                        </div>
                    )
                
                }

            </>

                :
                null
        }
        </>
    );
}
 
export default SearchBrands;